<template>
    <div>
        <ynav title="请选择疫苗名称"></ynav>
        <div class="ym_list">
            <h2>国家一类疫苗</h2>
            <ul>
                <li @click="pick('百白破疫苗')">百白破疫苗</li>
                <li @click="pick('白破疫苗')">白破疫苗</li>
                <li @click="pick('乙肝疫苗')">乙肝疫苗</li>
                <li @click="pick('甲肝疫苗')">甲肝疫苗</li>
                <li @click="pick('卡介疫苗')">卡介疫苗</li>
                <li @click="pick('脊灰疫苗')">脊灰疫苗</li>
                <li @click="pick('麻风疫苗')">麻风疫苗</li>
                <li @click="pick('麻腮风疫苗')">麻腮风疫苗</li>
                <li @click="pick('乙脑疫苗')">乙脑疫苗</li>
                <li @click="pick('A群流脑疫苗')">A群流脑疫苗</li>
                <li @click="pick('AC群流脑疫苗')">AC群流脑疫苗</li>
            </ul>
            <h2>其他疫苗</h2>
            <ul>
                <li @click="pick('13价肺炎疫苗')">13价肺炎疫苗</li>
                <li @click="pick('水痘疫苗')">水痘疫苗</li>
                <li @click="pick('流感疫苗')">流感疫苗</li>
                <li @click="pick('轮状病毒疫苗')">轮状病毒疫苗</li>
                <li @click="pick('麻疹疫苗')">麻疹疫苗</li>
                <li @click="pick('风疹疫苗')">风疹疫苗</li>
                <li @click="pick('戊肝疫苗')">戊肝疫苗</li>
                <li @click="pick('狂犬病疫苗')">狂犬病疫苗</li>
                <li @click="pick('破伤风疫苗')">破伤风疫苗</li>
                <li @click="pick('腮腺疫苗')">腮腺疫苗</li>
                <li @click="pick('7价肺炎疫苗')">7价肺炎疫苗</li>
                <li @click="pick('23价肺炎疫苗')">23价肺炎疫苗</li>
                <li @click="pick('4价脑膜炎疫苗')">4价脑膜炎疫苗</li>
                <li @click="pick('黄热减毒活疫苗')">黄热减毒活疫苗</li>
                <li @click="pick('钩端螺旋体疫苗')">钩端螺旋体疫苗</li>
                <li @click="pick('森林脑炎疫苗')">森林脑炎疫苗</li>
                <li @click="pick('伤寒Vi多糖疫苗')">伤寒Vi多糖疫苗</li>
                <li @click="pick('肾综合征出血热疫苗')">肾综合征出血热疫苗</li>
                <li @click="pick('b型流感嗜血杆菌结合疫苗')">b型流感嗜血杆菌结合疫苗</li>
                <li @click="pick('肠道病毒71型灭活疫苗')">肠道病毒71型灭活疫苗</li>
                <li @click="pick('HPV疫苗')">HPV疫苗</li>
            </ul>
        </div>
    </div>
</template>

<script>
import * as api from "../libs/api";
import ynav from "../components/nav";

export default {
  components: {
    ynav
  },
  data() {
    return {
      msg: "testA.vue"
    };
  },
  methods: {
    pick(value) {
      if (value) {
        this.$store.commit("pushName", value);
        this.$router.push({ name: "Index" });
      } else {
        alert("数据异常~");
      }
    }
  },

  mounted() {}
};
</script>




// WEBPACK FOOTER //
// src/views/SelectVaccine.vue